export function Sequencing(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.3126 3.9642L10.988 1.07239C11.6449 0.853435 12.355 0.853435 13.0119 1.07239L21.6873 3.9642C23.364 4.52307 24.2701 6.3353 23.7112 8.01192C23.5135 8.60499 23.1497 9.11881 22.6736 9.49944C23.6914 10.313 24.1473 11.7037 23.7112 13.0119C23.5135 13.605 23.1497 14.1188 22.6736 14.4994C23.6914 15.313 24.1473 16.7037 23.7112 18.0119C23.3927 18.9675 22.6429 19.7173 21.6873 20.0358L13.0119 22.9276C12.355 23.1465 11.6449 23.1465 10.988 22.9276L2.3126 20.0358C0.635978 19.4769 -0.270134 17.6647 0.288739 15.9881C0.486429 15.395 0.850267 14.8812 1.32632 14.5005C0.308499 13.687 -0.147328 12.2963 0.288739 10.9881C0.486429 10.395 0.850267 9.88117 1.32632 9.50054C0.308499 8.68702 -0.147328 7.29626 0.288739 5.98806C0.607251 5.03252 1.35706 4.28271 2.3126 3.9642ZM4.49997 15.7649L3.07154 16.241C2.83266 16.3207 2.64521 16.5081 2.56558 16.747C2.42586 17.1662 2.65239 17.6192 3.07154 17.7589L11.747 20.6507C11.9112 20.7055 12.0887 20.7055 12.253 20.6507L20.9284 17.7589C21.1673 17.6793 21.3547 17.4919 21.4344 17.253C21.5741 16.8338 21.3476 16.3808 20.9284 16.241L19.5 15.7649L13.0119 17.9276C12.355 18.1465 11.6449 18.1465 10.988 17.9276L4.49997 15.7649ZM13.0119 12.9276L19.5 10.7649L20.9284 11.241C21.3476 11.3808 21.5741 11.8338 21.4344 12.253C21.3547 12.4919 21.1673 12.6793 20.9284 12.7589L12.253 15.6507C12.0887 15.7055 11.9112 15.7055 11.747 15.6507L3.07154 12.7589C2.65239 12.6192 2.42586 12.1662 2.56558 11.747C2.64521 11.5081 2.83266 11.3207 3.07154 11.241L4.49997 10.7649L10.988 12.9276C11.6449 13.1465 12.355 13.1465 13.0119 12.9276ZM20.9284 6.24104L12.253 3.34923C12.0887 3.29449 11.9112 3.29449 11.747 3.34923L3.07154 6.24104C2.83266 6.32067 2.64521 6.50812 2.56558 6.74701C2.42586 7.16616 2.65239 7.61922 3.07154 7.75893L11.747 10.6507C11.9112 10.7055 12.0887 10.7055 12.253 10.6507L20.9284 7.75893C21.1673 7.67931 21.3547 7.49185 21.4344 7.25297C21.5741 6.83382 21.3476 6.38076 20.9284 6.24104Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
